import config from "config";

import { FC } from "react";
// MUI
import { IconButton } from "@mui/material";
import { PhoneOutlined } from '@mui/icons-material';
 
const PhoneButton:FC = () => {

  const { phoneNumber } = config;

  return (
    <IconButton
      component="a" href={`tel:${phoneNumber.replace(/\s+/g, '')}`}
      aria-label={phoneNumber}
      size="large"
      color="primary"
      sx={{
        display: { xs: 'inline-flex', md: 'none' },
        position: 'fixed',
        bottom: 16,
        right: 16
      }}
    >
      <PhoneOutlined fontSize="large" />
    </IconButton>
  );
}
 
export default PhoneButton;